module.exports = __webpack_public_path__ + "images/Blue_img-60b22bae97eb8c902145165c84f34688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Banner/Blue_img.jpg
// module id = 21
// module chunks = 0